import { AnalyticsPluginType } from '.';

declare global {
  interface Window {
    gtag: any;
  }
}

class GoogleAnalyticsPlugin implements AnalyticsPluginType {
  private initialized: boolean;

  constructor(googleAnalyticsTrackingId: any) {
    if (!window.gtag) {
      console.error(
        'Google Analytics "gtag" function was not installed before attempting to initialize. It may be blocked by an ad/tracking blocker.',
      );
      this.initialized = false;
    } else {
      window.gtag('config', googleAnalyticsTrackingId);
      this.initialized = true;
    }
  }

  identifyUser(
    userId: string,
    userProperties: Record<string, string | number>,
  ) {
    window.gtag('set', { user_id: userId });
  }

  isInitialized(): boolean {
    return this.initialized;
  }

  resetUser() {
    // ga has no clear way to reset user identity
  }

  trackEvent(category: string, action: string) {
    window.gtag('event', category, { action });
  }

  trackPageView(path: string) {
    window.gtag('event', 'page_view', { path });
  }
}

export default GoogleAnalyticsPlugin;
